import fetch from '../../../core/fetch';
import { setSiteSettings } from '../../../actions/siteSettings';
import showToaster from '../../../helpers/showToaster';
import { updateSiteSettings as query } from '../../../lib/graphql';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

async function submit(values, dispatch) {

  const isRestrict = await dispatch(demoRestriction({}));
  if (isRestrict) return;

  if (!values?.ogImage) {
    return showToaster({ messageId: 'ogImageError', toasterType: 'error' })
  }

  let variables = {
    ...values,
    homePageType: Number(values?.homePageType),
    phoneNumberStatus: Number(values?.phoneNumberStatus),
    appAvailableStatus: Boolean(values?.appAvailableStatus),
    securityDepositPreference: Number(values?.securityDepositPreference)
  };

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query,
      variables
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data?.updateSiteSettings?.status === 200) {
    showToaster({ messageId: 'updateSiteSettings', toasterType: 'success' })
    dispatch(setSiteSettings());
  } else {
    showToaster({ messageId: 'updateSettingsError', toasterType: 'error' })
  }
}

export default submit;
